module.exports = __webpack_public_path__ + "static/media/no-parking.63e6afa6.svg";